import { Flex, Spacer,useColorModeValue as colorValue } from '@chakra-ui/react'
import Header from './Header'
import { Home, Register, NotFound, QueueDefault, ManualDefault, RegulationsDefault } from '../../pages'
import Footer from './Footer'
import { Switch, Route } from 'react-router-dom'

const DefaultLayout = () => {
    return (
        <Flex direction="column" minH="100vh">
            <Header />
            <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/register" component={Register} />
                <Route path="/queue" component={QueueDefault} />
                <Route path="/manual" component={ManualDefault} />
                <Route path="/regulations" component={RegulationsDefault} />
                <Route component={NotFound} />
            </Switch>
            <Spacer bgColor={colorValue("gray.100", "gray.600")} />
            <Footer />
        </Flex>
    )
}

export default DefaultLayout
